import moment from "moment";
import {
  PrimitiveValueType,
  RowDataReducerState,
  RowDataReducerAction,
  GenericRowData,
} from "../../../../../types";
import { monthFirstSort } from "../../../helpers";

const FIELD_KEYS = {
  POSTING_MONTH_FIELD_KEY: "posting_month",
  POSTING_YEAR_FIELD_KEY: "posting_year",
  POSTING_CUTOFF_DATETIME_FIELD_KEY: "posting_cutoff_datetime",
};

// for combined GL calendar and fiscal year setups
export const enableActiveMonthPostingCutoffDateTime = (
  propertyKey: string,
  propertySubKey: string | undefined,
  inputValue: PrimitiveValueType | undefined,
  rowDataReducerState: RowDataReducerState,
  dispatch: React.Dispatch<RowDataReducerAction>,
): void => {
  if (propertySubKey && inputValue === true) {
    const monthsData = rowDataReducerState.rowData[
      propertyKey
    ] as GenericRowData[];
    const activeMonths =
      monthsData?.filter((data) => data[propertySubKey] === true) || [];
    if (activeMonths.length > 0) {
      let earliestMonthRecord = activeMonths[0];
      activeMonths.forEach((record) => {
        const currentMonth = moment(
          record[FIELD_KEYS.POSTING_MONTH_FIELD_KEY],
          "MMMM",
        );
        const earliestMonth = moment(
          earliestMonthRecord[FIELD_KEYS.POSTING_MONTH_FIELD_KEY],
          "MMMM",
        );
        if (currentMonth.isBefore(earliestMonth)) {
          earliestMonthRecord = record;
        }
      });
      const index = monthsData.findIndex(
        (data) =>
          data[FIELD_KEYS.POSTING_MONTH_FIELD_KEY] ===
          earliestMonthRecord[FIELD_KEYS.POSTING_MONTH_FIELD_KEY],
      );
      if (index > -1) {
        dispatch({
          type: "UPDATE_SCHEMA_PROPERTY_FIELD",
          payload: {
            propertyKey: propertyKey,
            propertyField: "disabled",
            newPropertyFieldValue: false,
            rowIndex: index,
            propertySubKey: FIELD_KEYS.POSTING_CUTOFF_DATETIME_FIELD_KEY,
          },
        });
      }
    }
  }
};

// for GL calendar setup

export const enableActiveMonthPostingCutoffDateTimeForGLCalendar = (
  propertyKey: string,
  inputValue: PrimitiveValueType | undefined,
  rowDataReducerState: RowDataReducerState,
  dispatch: React.Dispatch<RowDataReducerAction>,
): void => {
  if (inputValue !== true) {
    return;
  }

  const currentRowData = {
    ...rowDataReducerState.rowData,
    [propertyKey]: inputValue,
  };

  const postingYear = currentRowData[FIELD_KEYS.POSTING_YEAR_FIELD_KEY];

  const activeMonthsRowData = [
    ...rowDataReducerState.rowDataList,
    currentRowData,
  ].filter(
    (data) =>
      data[FIELD_KEYS.POSTING_YEAR_FIELD_KEY] === postingYear &&
      data[propertyKey] === true,
  );

  if (activeMonthsRowData.length === 0) {
    return;
  }

  const earliestMonthRecord = activeMonthsRowData.reduce(
    (earliest, current) => {
      const isEarlierMonth =
        monthFirstSort(
          String(current[FIELD_KEYS.POSTING_MONTH_FIELD_KEY]),
          String(earliest[FIELD_KEYS.POSTING_MONTH_FIELD_KEY]),
        ) < 0;

      return isEarlierMonth ? current : earliest;
    },
    activeMonthsRowData[0],
  );

  const isCurrentRowEarliestMonth =
    monthFirstSort(
      String(currentRowData[FIELD_KEYS.POSTING_MONTH_FIELD_KEY]),
      String(earliestMonthRecord[FIELD_KEYS.POSTING_MONTH_FIELD_KEY]),
    ) === 0;

  if (isCurrentRowEarliestMonth) {
    dispatch({
      type: "UPDATE_SCHEMA_PROPERTY_FIELD",
      payload: {
        propertyKey: FIELD_KEYS.POSTING_CUTOFF_DATETIME_FIELD_KEY,
        propertyField: "disabled",
        newPropertyFieldValue: false,
      },
    });
  }
};
